/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import { ofType } from "redux-observable"
import { concat, from } from "rxjs"
import { catchError, mergeMap } from "rxjs/operators"
import CONSTANTS from "../../assets/js/Constants"

/* const ThemMoiPhuTung = (action$, state$) => action$.pipe(
	ofType(CONSTANTS.ACTION.PHU_TUNG.POST_PHU_TUNG),
	mergeMap((action) => {
		const api = async () => {
			const arrayAction = []
			
			//arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.PHU_TUNG.SET_PHU_TUNG, danhSachPhuTung.data.data))
            return arrayAction
		}
		return concat(
			from(api()).pipe(
				mergeMap((res) => concat(from(res))),
				catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
			)
		)
	})
)
*/

const GetListPhuTung = (action$, state$) => action$.pipe(
	ofType(CONSTANTS.ACTION.PHU_TUNG.GET_LIST_PHU_TUNG),
	mergeMap((action) => {
		const api = async () => {
			let data = {}
			const danhSachPhuTung = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.PHU_TUNG.GET_LIST_PHU_TUNG, action.payload)

			const danhSachLoaiPhuTung = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.PHU_TUNG.GET_TYPE_PHU_TUNG, action.payload)
			
			

			// Lấy ds Loại phụ tùng

			// Lấy chi tiết phụ tùng đầu tiên trong danh sách
            // if (danhSachPhuTung.data.data.length > 0) {
			// 	const phuTungDauTien = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DRIVERS_TRANSPORTATION.GET_BY_ID, {
			// 	   driver_id: danhSachTaiXe.data.data[0].id
			// 	})
			// 	data.chiTietTaiXe = chiTietTaiXe.data.data
			//  } else {
			// 	data.chiTietTaiXe = {}
			//  }

			data = {
				danhSachPhuTung: danhSachPhuTung.data,
				danhSachLoaiPhuTung: danhSachLoaiPhuTung.data
			}
			
			
			const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.MENU.UPDATE_MENU_LIST, data))
            return arrayAction
		}
		return concat(
			from(api()).pipe(
				mergeMap((res) => concat(from(res))),
				catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
			)
		)
	})
)


const SearchPhuTung = (action$, state$) => action$.pipe(
	ofType(CONSTANTS.ACTION.PHU_TUNG.SEARCH_PHU_TUNG),
	mergeMap((action) => {
		const api = async () => {
			let params = ""
            if (action.payload.keyword !== null && action.payload.keyword.trim() !== "")
               params = `keyword=${action.payload.keyword}&start=${action.payload.page}`
            else params = `start=${action.payload.page}`
            console.log("🚀 ~ file: phu_tung_epic.js:36 ~ api ~ params:", params)
			const danhSachPhuTung = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.PHU_TUNG.GET_LIST_PHU_TUNG + params)
			const arrayAction = []	
			arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.PHU_TUNG.SET_PHU_TUNG, danhSachPhuTung.data))
            console.log("🚀 ~ file: phu_tung_epic.js:38 ~ api ~ arrayAction:", arrayAction)
            return arrayAction
		}
		return concat(
			from(api()).pipe(
				mergeMap((res) => concat(from(res))),
				catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
			)
		)
	})
)

const ThemMoiPhuTung = (action$, state$) => action$.pipe(
	ofType(CONSTANTS.ACTION.PHU_TUNG.POST_PHU_TUNG),
	mergeMap((action) => {
		const api = async () => {
			const arrayAction = []
			
			const postPhutung = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.PHU_TUNG.POST_PHU_TUNG, action.payload)			
			postPhutung.data.status
				? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, postPhutung.data.status))
				: arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, postPhutung.data.mess))
			
			// Reload new list
			const danhSachPhuTung = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.PHU_TUNG.GET_LIST_PHU_TUNG)			
			// arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.PHU_TUNG.SET_PHU_TUNG, danhSachPhuTung.data.data))
			arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.PHU_TUNG.SET_PHU_TUNG, danhSachPhuTung.data))
			
            return arrayAction
		}
		return concat(
			from(api()).pipe(
				mergeMap((res) => concat(from(res))),
				catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
			)
		)
	})
)

const CapNhatPhuTung = (action$, state$) => action$.pipe(
	ofType(CONSTANTS.ACTION.PHU_TUNG.PUT_PHU_TUNG),
	mergeMap((action) => {
		const api = async () => {
			const arrayAction = []
			
			const updatePhutung = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.PHU_TUNG.PUT_PHU_TUNG, action.payload)			
			updatePhutung.data.status
				? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, updatePhutung.data.status))
				: arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, updatePhutung.data.mess))
            
			// Reload new list
			const danhSachPhuTung = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.PHU_TUNG.GET_LIST_PHU_TUNG)			
			// arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.PHU_TUNG.SET_PHU_TUNG, danhSachPhuTung.data.data))
			arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.PHU_TUNG.SET_PHU_TUNG, danhSachPhuTung.data))
			
			return arrayAction
		}
		return concat(
			from(api()).pipe(
				mergeMap((res) => concat(from(res))),
				catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
			)
		)
	})
)

const XoaPhuTung = (action$, state$) => action$.pipe(
	ofType(CONSTANTS.ACTION.PHU_TUNG.DELETE_PHU_TUNG),
	mergeMap((action) => {
		const api = async () => {
			const arrayAction = []
			
			const deletePhutung = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.PHU_TUNG.DELETE_PHU_TUNG, action.payload)			
			deletePhutung.data.status
				? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, deletePhutung.data.status))
				: arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, deletePhutung.data.mess))
            
			// Reload new list
			arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.PHU_TUNG.GET_LIST_PHU_TUNG, {
				keyword: "",
				page: 1
			 }))
            
			return arrayAction
		}
		return concat(
			from(api()).pipe(
				mergeMap((res) => concat(from(res))),
				catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
			)
		)
	})
)

export default {
	GetListPhuTung,
	SearchPhuTung,
	ThemMoiPhuTung,
	CapNhatPhuTung,
	XoaPhuTung
}
